import axios from "axios"
import { getLabelToVote, getPositionStatus, getTypeMedio } from "../utils/medioTags"
import { tryCatchJsonParse } from "../../../utils/catch/tryCatchJson"
import { getId } from "../../../utils/getId"
import { useEffect, useState } from "react"
import { useQueryParms } from "../../../hooks/useQueryParams"
import { urlVoteMap } from "../utils/urlMap"

const getNominatedPlayers =  ({ medios, medioId, phase})=>{
    console.log('@@@medios', medios, medioId)
    const medioFound = medios?.find(medio => medio?._id === medioId)
    return medioFound?.votedBy?.[phase] || []

}
export const useHandlerVoting = ({goldenBallInfo, phase})=>{
    console.log('@@@', goldenBallInfo, phase)
        const {queryParams} = useQueryParms()
        const hasSpecialVote = queryParams.get('vote')
        const typeMedio = getTypeMedio(goldenBallInfo, hasSpecialVote)
        const playersVoteByMedio = getNominatedPlayers({medios: goldenBallInfo?.[typeMedio],
             medioId: hasSpecialVote, phase})
        console.log('@@@typeMedio', typeMedio)
        const keyStorage = `playersVoted-${phase}-${goldenBallInfo?._id}`
        const storePlayers =  playersVoteByMedio || tryCatchJsonParse(keyStorage, [])
        const [playersVoted, setPlayersVoted] = useState(storePlayers || []);
        const [positionPlayer, setPositionPlayer] = useState(getPositionStatus(playersVoted))
        const [isVoting, setIsVoting] = useState(false);
        const [selectedPlayer, setSelectedPlayer] = useState(null);
        console.log('@@@playersVoteByMedio', playersVoteByMedio)
    
    const editionId = getId([3])
        const handleVoteByPlayer = async (player)=>{
            
            setIsVoting(true)
            
            const params = {
                position: getLabelToVote(player,playersVoted),
                playerId: player?._id,
                id:editionId,
            }
            if(hasSpecialVote){
                params['type'] = getTypeMedio(goldenBallInfo, hasSpecialVote)
                params['specialId'] = hasSpecialVote 
                params['medioValue'] = goldenBallInfo?.valueMedioVote
                params['equipoValue'] = goldenBallInfo?.valueEquipoVote
                params['copaValue'] = goldenBallInfo?.valueCopaVote
            }
            const url = urlVoteMap[phase]
            try {
            const allPlayerVoted = [...playersVoted, player ]
            const votedPlayer = await  axios.post(url, params )
            await localStorage.setItem(keyStorage, JSON.stringify(allPlayerVoted))
            await setPlayersVoted(allPlayerVoted)
            await setPositionPlayer( getPositionStatus(tryCatchJsonParse(keyStorage, [])))
            await window.scrollTo(0,0)
            await setIsVoting(false)
            await setSelectedPlayer(null)
                
            } catch (error) {
                console.log('e', error)
                setIsVoting(false)
                setSelectedPlayer(null)
                
            }
    
        }
        useEffect(()=>{
            const players = playersVoteByMedio?.length > 0 ? playersVoteByMedio : tryCatchJsonParse(keyStorage, []) || []
            setPlayersVoted(players)
            setPositionPlayer(getPositionStatus(players))

        },[keyStorage, storePlayers?.length])

        useEffect(()=>{
            return ()=> setIsVoting(false)

        },[])

        return{
            handleVoteByPlayer,
            positionPlayer,
            hasSpecialVote,
            playersVoted,
            isVoting,
            selectedPlayer,
            setSelectedPlayer

        }
}